module.exports = __webpack_public_path__ + "static/media/example-2.440cb4c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyRunnersClub/example-2.jpg
// module id = 289
// module chunks = 0